/*
 * Build-your-own gift box.
 *
 * Holds the selection in memory, keeps the sticky tray in step, and posts the
 * finished box to the cart. All limits and pricing come from the section's
 * settings via data attributes — nothing about the catalogue is assumed here.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pfb-box]');
  if (!root) return;

  var MIN = parseInt(root.dataset.min, 10) || 1;
  var MAX = parseInt(root.dataset.max, 10) || MIN;
  var MODE = root.dataset.mode === 'fixed' ? 'fixed' : 'sum';
  var BOX_VARIANT = root.dataset.boxVariant || '';
  var FEE_VARIANT = root.dataset.feeVariant || '';
  var FEE_PRICE = FEE_VARIANT ? parseInt(root.dataset.feePrice, 10) || 0 : 0;
  var FEE_TITLE = root.dataset.feeTitle || 'gift box';
  var steps = root.querySelectorAll('[data-pfb-steps] li');

  var tray = root.querySelector('[data-pfb-tray]');
  var slotsEl = root.querySelector('[data-pfb-slots]');
  var statusEl = root.querySelector('[data-pfb-status]');
  var totalEl = root.querySelector('[data-pfb-total]');
  var submitEl = root.querySelector('[data-pfb-submit]');
  var noteEl = root.querySelector('[data-pfb-note]');

  /** @type {{variant:string,title:string,price:number,image:string}[]} */
  var chosen = [];

  function money(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  function plural(n) {
    return n === 1 ? 'item' : 'items';
  }

  function render() {
    tray.hidden = chosen.length === 0;

    // One slot per allowed item, filled left to right, so the box always shows
    // how much room is left rather than only what's in it.
    slotsEl.innerHTML = '';
    for (var i = 0; i < MAX; i++) {
      var li = document.createElement('li');
      li.className = 'pfb-box__slot';
      var item = chosen[i];
      if (item) {
        li.classList.add('pfb-box__slot--filled');
        li.innerHTML =
          '<img src="' + item.image + '" alt="" loading="lazy">' +
          '<button type="button" class="pfb-box__remove" data-remove="' + i + '" ' +
          'aria-label="Remove ' + item.title.replace(/"/g, '&quot;') + '">&times;</button>';
      } else {
        li.innerHTML = '<span class="pfb-box__slot-mark" aria-hidden="true">+</span>';
      }
      slotsEl.appendChild(li);
    }

    var left = MIN - chosen.length;
    statusEl.textContent = left > 0
      ? 'Choose ' + left + ' more ' + plural(left)
      : chosen.length < MAX
        ? 'Add up to ' + (MAX - chosen.length) + ' more, or check out'
        : 'Your box is full';

    if (MODE === 'sum' && chosen.length) {
      // Show what the cart will actually say, packaging included, so the total
      // doesn't jump the moment the box lands in the cart.
      var sum = chosen.reduce(function (t, i) { return t + i.price; }, 0) + FEE_PRICE;
      totalEl.innerHTML = money(sum) + (FEE_PRICE
        ? '<small>incl. ' + FEE_TITLE + ' ' + money(FEE_PRICE) + '</small>'
        : '');
    } else {
      totalEl.textContent = '';
    }

    // Step guide: 1 until the box has enough pieces, then 2 (note), then 3.
    var noteDone = noteEl && noteEl.value.trim();
    var stage = chosen.length < MIN ? 1 : noteDone ? 3 : 2;
    steps.forEach(function (li) {
      var n = parseInt(li.dataset.step, 10);
      li.classList.toggle('is-active', n === stage);
      li.classList.toggle('is-done', n < stage);
    });

    submitEl.disabled = chosen.length < MIN;

    // Sold-out-style state on cards already in the box, and lock the rest once
    // the box is full.
    root.querySelectorAll('[data-pfb-add]').forEach(function (btn) {
      var inBox = chosen.some(function (i) { return i.variant === btn.dataset.variant; });
      btn.closest('.pfb-box__card').classList.toggle('pfb-box__card--chosen', inBox);
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      if (!btn.hasAttribute('data-out')) btn.textContent = inBox ? 'Added ✓' : btn.dataset.label;
      if (!btn.hasAttribute('data-out')) {
        btn.disabled = !inBox && chosen.length >= MAX;
      }
      var pick = btn.closest('.pfb-box__card').querySelector('[data-pfb-variant]');
      if (pick) pick.disabled = inBox;
    });
  }

  root.addEventListener('click', function (event) {
    var add = event.target.closest('[data-pfb-add]');
    if (add) {
      // Pressing "Added ✓" again takes the piece back out, rather than adding
      // a second one of the same thing.
      var at = chosen.findIndex(function (i) { return i.variant === add.dataset.variant; });
      if (at !== -1) {
        chosen.splice(at, 1);
        render();
        return;
      }
      if (chosen.length >= MAX) return;
      var picker = add.closest('.pfb-box__card').querySelector('[data-pfb-variant]');
      var label = picker
        ? add.dataset.title + ' — ' + picker.options[picker.selectedIndex].text
        : add.dataset.title;
      chosen.push({
        variant: add.dataset.variant,
        title: label,
        price: parseInt(add.dataset.price, 10) || 0,
        image: add.dataset.image,
      });
      render();
      return;
    }

    var remove = event.target.closest('[data-remove]');
    if (remove) {
      chosen.splice(parseInt(remove.dataset.remove, 10), 1);
      render();
    }
  });

  root.addEventListener('change', function (event) {
    var sel = event.target.closest('[data-pfb-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('.pfb-box__card');
    var btn = card.querySelector('[data-pfb-add]');
    btn.dataset.variant = opt.value;
    btn.dataset.price = opt.dataset.price;
    if (opt.dataset.image) btn.dataset.image = opt.dataset.image;
    card.querySelector('[data-pfb-price]').textContent = opt.dataset.money;
    render();
  });

  if (noteEl) noteEl.addEventListener('input', render);

  tray.addEventListener('submit', function (event) {
    event.preventDefault();
    if (chosen.length < MIN) return;

    submitEl.disabled = true;
    submitEl.classList.add('pfb-box__submit--busy');

    // One id ties the lines together, so the packing slip shows which items
    // belong to which box when someone orders two.
    var boxId = 'BOX-' + Date.now().toString(36).toUpperCase();
    var contents = chosen.map(function (i) { return i.title; }).join(', ');
    var note = noteEl && noteEl.value.trim();

    var items;
    if (MODE === 'fixed' && BOX_VARIANT) {
      var props = { 'Box contents': contents };
      if (note) props['Gift note'] = note;
      items = [{ id: Number(BOX_VARIANT), quantity: 1, properties: props }];
    } else {
      items = chosen.map(function (i) {
        var props = { 'Gift box': boxId };
        if (note) props['Gift note'] = note;
        return { id: Number(i.variant), quantity: 1, properties: props };
      });
      if (FEE_VARIANT) {
        items.push({
          id: Number(FEE_VARIANT),
          quantity: 1,
          properties: { 'Gift box': boxId, 'Box contents': contents },
        });
      }
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart rejected the box');
        return r.json();
      })
      .then(function () {
        window.location.href = window.Shopify.routes.root + 'cart';
      })
      .catch(function () {
        submitEl.disabled = false;
        submitEl.classList.remove('pfb-box__submit--busy');
        statusEl.textContent = "Sorry — that didn't go through. Please try again.";
      });
  });

  // Mark the sold-out buttons so the full-box lock never re-enables them.
  root.querySelectorAll('[data-pfb-add][disabled]').forEach(function (b) {
    b.setAttribute('data-out', '');
  });

  render();
})();
